/* eslint-disable */
export default {
  收货人信息: '收货人信息',
  新增收货地址: '新增收货地址',
  '您还没有收货地址，赶快添加吧！': '您还没有收货地址，赶快添加吧！',
  收起: '收起',
  更多地址: '更多地址',
  姓名: '姓名',
  请输入收货人: '请输入收货人',
  电话: '电话',
  请输入联系电话: '请输入联系电话',
  地址: '地址',
  详细地址: '详细地址',
  请输入详细地址: '请输入详细地址',
  '保 存': '保 存',
  '取 消': '取 消',
  长度不可以超过50个字符: '长度不可以超过50个字符',
  长度不可以超过20个字符: '长度不可以超过20个字符',
  请选择地址: '请选择地址',
  长度不可以超过100个字符: '长度不可以超过100个字符',
  退出: '退出',
  首页: '首页',
  我的文件: '我的文件',
  企业文件: '企业文件',
  我的模板: '我的模板',
  企业模板: '企业模板',
  审批管理: '审批管理',
  用户中心: '用户中心',
  费用中心: '费用中心',
  证据中心: '证据中心',
  发票寄送信息: '发票寄送信息',
  顺丰快递价格: '顺丰快递价格',
  元: '元',
  支付快递费: '支付快递费',
  货到付款: '货到付款',
  '注意：目前暂不支持开具快递费发票，您可选择“货到付款”后向顺丰快递索要发票。':
    '注意：目前暂不支持开具快递费发票，您可选择“货到付款”后向顺丰快递索要发票。',
  江苏省: '江苏省',
  浙江省: '浙江省',
  上海市: '上海市',
  西藏自治区: '西藏自治区',
  新疆维吾尔自治区: '新疆维吾尔自治区',
  宁夏回族自治区: '宁夏回族自治区',
  澳门特别行政区: '澳门特别行政区',
  香港特别行政区: '香港特别行政区',
  e签宝: 'e签宝',
  '快速选择：': '快速选择：',
  序号: '序号',
  服务名称: '服务名称',
  '本订单价格（元/次）': '本订单价格（元/次）',
  '被转售方价格（元/次）': '被转售方价格（元/次）',
  '实际价格（元/次）': '实际价格（元/次）',
  '设置调价倍数：': '设置调价倍数：',
  应用: '应用',
  '确定后系统将按本订单价格*调价倍数更新被转售方价格': '确定后系统将按本订单价格*调价倍数更新被转售方价格',
  '请输入1-10以内的数字，最多1位小数': '请输入1-10以内的数字，最多1位小数',
  取消: '取消',
  确定: '确定',
  知道了: '知道了',
  '签署密码:': '签署密码:',
  请输入签署密码: '请输入签署密码',
  输入价格不符合规范: '输入价格不符合规范',
  '此价格低于本订单价格，不能提交': '此价格低于本订单价格，不能提交',
  还未勾选子服务项: '还未勾选子服务项',
  存在已勾选但未设置被转售方价格的子服务项: '存在已勾选但未设置被转售方价格的子服务项',
  充值子项允许0元计费: '充值子项允许0元计费',
  '元/次': '元/次',
  类别: '类别',
  服务状态: '服务状态',
  价格审核中: '价格审核中',
  已开通: '已开通',
  未开通: '未开通',
  '价格（元/次）': '价格（元/次）',
  标准价: '标准价',
  一月: '一月',
  二月: '二月',
  三月: '三月',
  四月: '四月',
  五月: '五月',
  六月: '六月',
  七月: '七月',
  八月: '八月',
  九月: '九月',
  十月: '十月',
  十一月: '十一月',
  十二月: '十二月',
  消费时间: '消费时间',
  平台名称: '平台名称',
  签署人: '签署人',
  签署ID: '签署ID',
  消费数量: '消费数量',
  扣费方: '扣费方',
  签署任务名称: '签署任务名称',
  签署任务ID: '签署任务ID',
  消费主体: '消费主体',
  子服务名称: '子服务名称',
  使用方: '使用方',
  账号ID: '账号ID',
  消费金额: '消费金额',
  业务ID: '业务ID',
  证件号: '证件号',
  结果描述: '结果描述',
  存证类型: '存证类型',
  存证份数: '存证份数',
  存证编号: '存证编号',
  持有人名字: '持有人名字',
  CA通道名称: 'CA通道名称',
  出证申请人: '出证申请人',
  出证编号: '出证编号',
  订单号: '订单号',
  出证类型: '出证类型',
  合同数: '合同数',
  实际消费数: '实际消费数',
  AI类型: 'AI类型',
  AI编号: 'AI编号',
  授权企业GID: '授权企业GID',
  被授权企业GID: '被授权企业GID',
  使用情况: '使用情况',
  国家开发银行: '国家开发银行',
  中国工商银行: '中国工商银行',
  中国农业银行: '中国农业银行',
  中国银行: '中国银行',
  中国建设银行: '中国建设银行',
  中国邮政储蓄银行: '中国邮政储蓄银行',
  交通银行: '交通银行',
  招商银行: '招商银行',
  上海浦东发展银行: '上海浦东发展银行',
  兴业银行: '兴业银行',
  华夏银行: '华夏银行',
  广东发展银行: '广东发展银行',
  中国民生银行: '中国民生银行',
  中信银行: '中信银行',
  中国光大银行: '中国光大银行',
  恒丰银行: '恒丰银行',
  浙商银行: '浙商银行',
  渤海银行: '渤海银行',
  平安银行: '平安银行',
  上海农村商业银行: '上海农村商业银行',
  玉溪市商业银行: '玉溪市商业银行',
  尧都农商行: '尧都农商行',
  北京银行: '北京银行',
  上海银行: '上海银行',
  江苏银行: '江苏银行',
  杭州银行: '杭州银行',
  南京银行: '南京银行',
  宁波银行: '宁波银行',
  徽商银行: '徽商银行',
  长沙银行: '长沙银行',
  成都银行: '成都银行',
  重庆银行: '重庆银行',
  大连银行: '大连银行',
  南昌银行: '南昌银行',
  福建海峡银行: '福建海峡银行',
  汉口银行: '汉口银行',
  温州银行: '温州银行',
  青岛银行: '青岛银行',
  台州银行: '台州银行',
  嘉兴银行: '嘉兴银行',
  常熟农村商业银行: '常熟农村商业银行',
  南海农村信用联社: '南海农村信用联社',
  常州农村信用联社: '常州农村信用联社',
  内蒙古银行: '内蒙古银行',
  绍兴银行: '绍兴银行',
  顺德农商银行: '顺德农商银行',
  吴江农商银行: '吴江农商银行',
  齐商银行: '齐商银行',
  贵阳市商业银行: '贵阳市商业银行',
  遵义市商业银行: '遵义市商业银行',
  湖州市商业银行: '湖州市商业银行',
  龙江银行: '龙江银行',
  晋城银行JCBANK: '晋城银行JCBANK',
  浙江泰隆商业银行: '浙江泰隆商业银行',
  广东省农村信用社联合社: '广东省农村信用社联合社',
  东莞农村商业银行: '东莞农村商业银行',
  浙江民泰商业银行: '浙江民泰商业银行',
  广州银行: '广州银行',
  辽阳市商业银行: '辽阳市商业银行',
  江苏省农村信用联合社: '江苏省农村信用联合社',
  廊坊银行: '廊坊银行',
  浙江稠州商业银行: '浙江稠州商业银行',
  德阳商业银行: '德阳商业银行',
  晋中市商业银行: '晋中市商业银行',
  苏州银行: '苏州银行',
  桂林银行: '桂林银行',
  乌鲁木齐市商业银行: '乌鲁木齐市商业银行',
  成都农商银行: '成都农商银行',
  张家港农村商业银行: '张家港农村商业银行',
  东莞银行: '东莞银行',
  莱商银行: '莱商银行',
  北京农村商业银行: '北京农村商业银行',
  天津农商银行: '天津农商银行',
  上饶银行: '上饶银行',
  富滇银行: '富滇银行',
  重庆农村商业银行: '重庆农村商业银行',
  鞍山银行: '鞍山银行',
  宁夏银行: '宁夏银行',
  河北银行: '河北银行',
  华融湘江银行: '华融湘江银行',
  自贡市商业银行: '自贡市商业银行',
  云南省农村信用社: '云南省农村信用社',
  吉林银行: '吉林银行',
  东营市商业银行: '东营市商业银行',
  昆仑银行: '昆仑银行',
  鄂尔多斯银行: '鄂尔多斯银行',
  邢台银行: '邢台银行',
  晋商银行: '晋商银行',
  天津银行: '天津银行',
  营口银行: '营口银行',
  吉林农信: '吉林农信',
  山东农信: '山东农信',
  西安银行: '西安银行',
  河北省农村信用社: '河北省农村信用社',
  宁夏黄河农村商业银行: '宁夏黄河农村商业银行',
  贵州省农村信用社: '贵州省农村信用社',
  阜新银行: '阜新银行',
  湖北银行黄石分行: '湖北银行黄石分行',
  浙江省农村信用社联合社: '浙江省农村信用社联合社',
  新乡银行: '新乡银行',
  湖北银行宜昌分行: '湖北银行宜昌分行',
  乐山市商业银行: '乐山市商业银行',
  江苏太仓农村商业银行: '江苏太仓农村商业银行',
  驻马店银行: '驻马店银行',
  赣州银行: '赣州银行',
  无锡农村商业银行: '无锡农村商业银行',
  广西北部湾银行: '广西北部湾银行',
  广州农商银行: '广州农商银行',
  江苏江阴农村商业银行: '江苏江阴农村商业银行',
  平顶山银行: '平顶山银行',
  泰安市商业银行: '泰安市商业银行',
  南充市商业银行: '南充市商业银行',
  重庆三峡银行: '重庆三峡银行',
  中山小榄村镇银行: '中山小榄村镇银行',
  邯郸银行: '邯郸银行',
  库尔勒市商业银行: '库尔勒市商业银行',
  锦州银行: '锦州银行',
  齐鲁银行: '齐鲁银行',
  青海银行: '青海银行',
  阳泉银行: '阳泉银行',
  盛京银行: '盛京银行',
  抚顺银行: '抚顺银行',
  郑州银行: '郑州银行',
  深圳农村商业银行: '深圳农村商业银行',
  潍坊银行: '潍坊银行',
  九江银行: '九江银行',
  江西省农村信用: '江西省农村信用',
  河南省农村信用: '河南省农村信用',
  甘肃省农村信用: '甘肃省农村信用',
  四川省农村信用: '四川省农村信用',
  广西省农村信用: '广西省农村信用',
  陕西信合: '陕西信合',
  武汉农村商业银行: '武汉农村商业银行',
  宜宾市商业银行: '宜宾市商业银行',
  昆山农村商业银行: '昆山农村商业银行',
  石嘴山银行: '石嘴山银行',
  衡水银行: '衡水银行',
  信阳银行: '信阳银行',
  鄞州银行: '鄞州银行',
  张家口市商业银行: '张家口市商业银行',
  许昌银行: '许昌银行',
  济宁银行: '济宁银行',
  开封市商业银行: '开封市商业银行',
  威海市商业银行: '威海市商业银行',
  湖北银行: '湖北银行',
  承德银行: '承德银行',
  丹东银行: '丹东银行',
  金华银行: '金华银行',
  朝阳银行: '朝阳银行',
  临商银行: '临商银行',
  包商银行: '包商银行',
  兰州银行: '兰州银行',
  周口银行: '周口银行',
  德州银行: '德州银行',
  三门峡银行: '三门峡银行',
  安阳银行: '安阳银行',
  安徽省农村信用社: '安徽省农村信用社',
  湖北省农村信用社: '湖北省农村信用社',
  湖南省农村信用社: '湖南省农村信用社',
  广东南粤银行: '广东南粤银行',
  洛阳银行: '洛阳银行',
  农信银清算中心: '农信银清算中心',
  城市商业银行资金清算中心: '城市商业银行资金清算中心',
  新签: '新签',
  续签: '续签',
  我的账户: '我的账户',
  我的订单: '我的订单',
  我的账单: '我的账单',
  '今天 {slot1}': '今天 {slot1}',
  '昨天 {slot1}': '昨天 {slot1}',
  当前信息: '当前信息',
  '用户ID：': '用户ID：',
  '账号名称：': '账号名称：',
  '证件类型：': '证件类型：',
  '证件号：': '证件号：',
  '联系地址：': '联系地址：',
  '联系电话：': '联系电话：',
  '姓名：': '姓名：',
  进入统一用户中心: '进入统一用户中心',
  当前: '当前',
  企业: '企业',
  个人: '个人',
  '并无实名认证,请前往用户中心实名认证后再进行查看。': '并无实名认证,请前往用户中心实名认证后再进行查看。',
  开始实名认证: '开始实名认证',
  提现申请: '提现申请',
  可提现余额: '可提现余额',
  提现中: '提现中',
  提现金额: '提现金额',
  '为保障您所在的主体账户资金安全，一天内一个主体仅能操作提现1次，请谨慎操作！':
    '为保障您所在的主体账户资金安全，一天内一个主体仅能操作提现1次，请谨慎操作！',
  '请输入大于1.00元的数字': '请输入大于1.00元的数字',
  提现至银行账户: '提现至银行账户',
  '请保证银行账户信息准确且未失效，否则将无法打款成功！': '请保证银行账户信息准确且未失效，否则将无法打款成功！',
  开户行全称: '开户行全称',
  请输入开户行关键词: '请输入开户行关键词',
  提现银行: '提现银行',
  银行账户名: '银行账户名',
  银行账号: '银行账号',
  修改银行卡: '修改银行卡',
  确认提现: '确认提现',
  提现验证: '提现验证',
  '为保障您的账户安全，请输入签署密码：': '为保障您的账户安全，请输入签署密码：',
  '管理员手机号：': '管理员手机号：',
  '手机号：': '手机号：',
  '邮箱：': '邮箱：',
  '验证码：': '验证码：',
  请输入6位验证码: '请输入6位验证码',
  '{time} 秒后获取': '{time} 秒后获取',
  发送验证码: '发送验证码',
  使用动态验证码: '使用动态验证码',
  使用签署密码: '使用签署密码',
  '还没有签署密码？': '还没有签署密码？',
  去设置: '去设置',
  '确 定': '确 定',
  请输入提现金额: '请输入提现金额',
  '请输入正确的提现金额，保留2位有效数字': '请输入正确的提现金额，保留2位有效数字',
  '输入金额不能超过可提现余额(单次最多提现300元)': '输入金额不能超过可提现余额(单次最多提现300元)',
  签署密码: '签署密码',
  验证码: '验证码',
  '{text}不能为空': '{text}不能为空',
  验证码格式不正确: '验证码格式不正确',
  请输入开户行全称: '请输入开户行全称',
  请输入银行账号: '请输入银行账号',
  '银行卡账号长度不能小于8位(数字)': '银行卡账号长度不能小于8位(数字)',
  参数错误: '参数错误',
  '您的可提现金额小于 1 元，不可提现！': '您的可提现金额小于 1 元，不可提现！',
  '确认是否提现?': '确认是否提现?',
  提示: '提示',
  '验证码已发送!': '验证码已发送!',
  '发送验证码失败!': '发送验证码失败!',
  '您已发起{amount}元提现申请！': '您已发起{amount}元提现申请！',
  '抱歉，您发起的{amount}元提现申请失败了！': '抱歉，您发起的{amount}元提现申请失败了！',
  'e签宝将在2~3个工作日内处理您的提现申请，提现结果可登录钱包页面查看或及时查收短信。':
    'e签宝将在2~3个工作日内处理您的提现申请，提现结果可登录钱包页面查看或及时查收短信。',
  返回: '返回',
  重新申请: '重新申请',
  '提示：如相应资金长时间未到账，请咨询相关银行或拨打客服热线：400-087-8198。':
    '提示：如相应资金长时间未到账，请咨询相关银行或拨打客服热线：400-087-8198。',
  我的账单记录: '我的账单记录',
  '提示：当月用量统计截止昨天24:00。': '提示：当月用量统计截止昨天24:00。',
  账单时间: '账单时间',
  选择日期: '选择日期',
  请选择: '请选择',
  请输入: '请输入',
  产品名称: '产品名称',
  订单编号: '订单编号',
  查询: '查询',
  清空: '清空',
  导出: '导出',
  '共用掉{amount}{units}': '共用掉{amount}{units}',
  暂无更多数据: '暂无更多数据',
  导出消费记录: '导出消费记录',
  已导出记录查询: '已导出记录查询',
  请选择产品名称: '请选择产品名称',
  月度区间: '月度区间',
  请选择月度区间: '请选择月度区间',
  开始月份: '开始月份',
  结束月份: '结束月份',
  '消费记录生成中，请稍等…': '消费记录生成中，请稍等…',
  至: '至',
  明细下载: '明细下载',
  关闭: '关闭',
  已导出消费记录: '已导出消费记录',
  请选择产品名称筛选: '请选择产品名称筛选',
  全部产品: '全部产品',
  导出成功: '导出成功',
  导出失败: '导出失败',
  '(已过期)': '(已过期)',
  暂无数据: '暂无数据',
  好的: '好的',
  请选择产品: '请选择产品',
  暂不支持超过三个月时间宽度的导出操作: '暂不支持超过三个月时间宽度的导出操作',
  请输入产品名称: '请输入产品名称',
  请输入月度区间: '请输入月度区间',
  发货时间: '发货时间',
  '共收货{amount}个': '共收货{amount}个',
  导出发货记录: '导出发货记录',
  发货ID: '发货ID',
  发货状态: '发货状态',
  发件人: '发件人',
  发件数量: '发件数量',
  收件人: '收件人',
  '{month}月': '{month}月',
  '发货记录生成中，请稍等…': '发货记录生成中，请稍等…',
  '发起的发货记录导出请求已经生成完毕。': '发起的发货记录导出请求已经生成完毕。',
  '您的转售存在转售数量小于搭售要求的规格{slot}份的操作，不会搭售对应套餐':
    '您的转售存在转售数量小于搭售要求的规格{slot}份的操作，不会搭售对应套餐',
  '注意：您的转售存在转售数量小于搭售要求的规格{slot}份的操作，不会搭售对应套餐':
    '注意：您的转售存在转售数量小于搭售要求的规格{slot}份的操作，不会搭售对应套餐',
  下载: '下载',
  待发货: '待发货',
  下单失败: '下单失败',
  已发货: '已发货',
  已取消: '已取消',
  需追回: '需追回',
  已追回: '已追回',
  已冻结: '已冻结',
  已收货: '已收货',
  查看发票: '查看发票',
  拼命加载中: '拼命加载中',
  下载发票: '下载发票',
  '开票系统维护中，请稍后再试': '开票系统维护中，请稍后再试',
  操作转售: '操作转售',
  订单授权: '订单授权',
  '转售订单不可消费，若您在转售后希望使用此订单部分份额，请对您自己转售部分份额，请注意，所有转售份额不可取消；':
    '转售订单不可消费，若您在转售后希望使用此订单部分份额，请对您自己转售部分份额，请注意，所有转售份额不可取消；',
  '*可授权企业用户须线下走授权申请': '*可授权企业用户须线下走授权申请',
  '订单编号：': '订单编号：',
  产品规格数量: '产品规格数量',
  有效时间: '有效时间',
  已转售量: '已转售量',
  已使用量: '已使用量',
  剩余可转售量: '剩余可转售量',
  当前余量: '当前余量',
  付款状态: '付款状态',
  无限: '无限',
  待支付: '待支付',
  已支付: '已支付',
  付款中: '付款中',
  未支付: '未支付',
  '总共可转售：': '总共可转售：',
  当前总共可授权数量: '当前总共可授权数量',
  添加授权方: '添加授权方',
  可授权用户: '可授权用户',
  '选择：': '选择：',
  请输入授权用户名称: '请输入授权用户名称',
  无信息: '无信息',
  全选: '全选',
  已选: '已选',
  选择授权方名称: '选择授权方名称',
  方式选择: '方式选择',
  最大可用量: '最大可用量',
  操作: '操作',
  配额: '配额',
  共享: '共享',
  请输入数字: '请输入数字',
  选择被转售方名称: '选择被转售方名称',
  '（每次最多新增5个）': '（每次最多新增5个）',
  有效期: '有效期',
  '被转售方可使用此转售订单的时间范围，此时间范围应处于主订单有效期范围内；':
    '被转售方可使用此转售订单的时间范围，此时间范围应处于主订单有效期范围内；',
  请输入相关企业完整证件号或个人完整身份证: '请输入相关企业完整证件号或个人完整身份证',
  开通子服务: '开通子服务',
  '+ 添加': '+ 添加',
  下一步: '下一步',
  开通子服务项: '开通子服务项',
  重复授权提醒: '重复授权提醒',
  '共享模式同一个订单一个用户只能共享一次，如下用户存在重复共享': '共享模式同一个订单一个用户只能共享一次，如下用户存在重复共享',
  重复被授权用户: '重复被授权用户',
  '请输入相关企业完整证件号,每次最多添加20个,可多次': '请输入相关企业完整证件号,每次最多添加20个,可多次',
  '请输入个人完整身份证号,每次最多添加20个,可多次': '请输入个人完整身份证号,每次最多添加20个,可多次',
  年: '年',
  月: '月',
  日: '日',
  请输入30位以内字母或数字: '请输入30位以内字母或数字',
  您输入的相关企业完整证件号或个人完整身份证不存在: '您输入的相关企业完整证件号或个人完整身份证不存在',
  '同个客户同个商品仅支持一种授权模式，若需此操作，请先取消原有授权方式！':
    '同个客户同个商品仅支持一种授权模式，若需此操作，请先取消原有授权方式！',
  添加的授权数量不能大于可授权数量: '添加的授权数量不能大于可授权数量',
  '生效日期: {slot1} ~ {slot2}': '生效日期: {slot1} ~ {slot2}',
  以上被转售方的有效期超出了您主订单的有效期: '以上被转售方的有效期超出了您主订单的有效期',
  '{slot1}，请您调整他们的有效期；': '{slot1}，请您调整他们的有效期；',
  '当前已有生效中的相同产品订单,有效期截止{slot1},请您确认生效日期和有效期！':
    '当前已有生效中的相同产品订单,有效期截止{slot1},请您确认生效日期和有效期！',
  请您确认生效日期和有效期: '请您确认生效日期和有效期',
  请添加被授权方: '请添加被授权方',
  授权数量不能为0: '授权数量不能为0',
  请输入被转售方: '请输入被转售方',
  '{slot1}还未选子服务项/添加价格，它将无法使用{slot2}订单，请先勾选再确认转售':
    '{slot1}还未选子服务项/添加价格，它将无法使用{slot2}订单，请先勾选再确认转售',
  '请输入最小为1的整数,总共可转售量为{slot1}': '请输入最小为1的整数,总共可转售量为{slot1}',
  请选择生效日期: '请选择生效日期',
  超过总量: '超过总量',
  有效期提醒: '有效期提醒',
  订单提醒: '订单提醒',
  '注意！本次操作配额总量大于90%，授权企业该产品余量由{slot1}变更为{slot2}，可能导致授权企业与其他被授权企业的运行中的服务中断，请核实后确认':
    '注意！本次操作配额总量大于90%，授权企业该产品余量由{slot1}变更为{slot2}，可能导致授权企业与其他被授权企业的运行中的服务中断，请核实后确认',
  '提示：被授权企业下有生效中的订单，本次授权操作后，依旧会优先扣减原订单余量':
    '提示：被授权企业下有生效中的订单，本次授权操作后，依旧会优先扣减原订单余量',
  配额数量必须大于0: '配额数量必须大于0',
  配额总数不能超过当前可授权数量: '配额总数不能超过当前可授权数量',
  开票: '开票',
  '提示：可能有部分金额已开过发票，此处不计入可开票金额内。': '提示：可能有部分金额已开过发票，此处不计入可开票金额内。',
  合并: '合并',
  '开票总金额：': '开票总金额：',
  '合并开票总金额：': '合并开票总金额：',
  '开票订单：': '开票订单：',
  '{slot1}笔': '{slot1}笔',
  '{slot1}元': '{slot1}元',
  '（其中 {slot1}，将按归属公司分别合并开票）': '（其中 {slot1}，将按归属公司分别合并开票）',
  开票信息: '开票信息',
  '发票抬头:': '发票抬头:',
  '纳税人识别号:': '纳税人识别号:',
  请输入内容: '请输入内容',
  '发票类型:': '发票类型:',
  '  电子票开具后，我们会直接通过邮件向您发送对应票据': '电子票开具后，我们会直接通过邮件向您发送对应票据',
  增值税普通发票: '增值税普通发票',
  增值税专用发票: '增值税专用发票',
  '发票形式:': '发票形式:',
  纸质发票: '纸质发票',
  电子发票: '电子发票',
  开户银行: '开户银行',
  请选择开户银行: '请选择开户银行',
  开票地址: '开票地址',
  开票电话: '开票电话',
  '开票电话，例:18899990000 或 0571-12345678-001 或 400-888-8888': '开票电话，例:18899990000 或 0571-12345678-001 或 400-888-8888',
  '开票备注(非实际开票上的备注内容)': '开票备注(非实际开票上的备注内容)',
  '开票备注:': '开票备注:',
  '若有特殊开票注意事项，请留言，系统将根据您的需求流转至开票人员': '若有特殊开票注意事项，请留言，系统将根据您的需求流转至开票人员',
  确认提交: '确认提交',
  请输入纳税人识别号: '请输入纳税人识别号',
  请输入开票地址: '请输入开票地址',
  请输入接收邮箱: '请输入接收邮箱',
  请正确填写接收邮箱: '请正确填写接收邮箱',
  请填写开票电话: '请填写开票电话',
  '请正确填写联系号码：例如：18899990000 或 0571-12345678-001 或 400-888-8888':
    '请正确填写联系号码：例如：18899990000 或 0571-12345678-001 或 400-888-8888',
  '暂不支持500元以下开具增值税专用发票，如需帮助可拨打客服热线：400-087-8198':
    '暂不支持500元以下开具增值税专用发票，如需帮助可拨打客服热线：400-087-8198',
  '开票金额不能为0!': '开票金额不能为0!',
  '请先设置收货地址 !': '请先设置收货地址 !',
  '开票银行名称和开票银行账户需要同时输入或是同时为空，您已输入其中一条信息，请填写完整信息':
    '开票银行名称和开票银行账户需要同时输入或是同时为空，您已输入其中一条信息，请填写完整信息',
  '开票地址和开票电话需要同时输入或是同时为空，您已输入其中一条信息，请填写完整信息':
    '开票地址和开票电话需要同时输入或是同时为空，您已输入其中一条信息，请填写完整信息',
  '开票地址过长，系统无法支持，建议字数控制在40个字以内': '开票地址过长，系统无法支持，建议字数控制在40个字以内',
  '抱歉，单次发票可开具金额为99999.99，请联系客服获取发票。': '抱歉，单次发票可开具金额为99999.99，请联系客服获取发票。',
  '{slot1} {slot2} 笔': '{slot1} {slot2} 笔',
  剩余可用总量: '剩余可用总量',
  预扣用量: '预扣用量',
  剩余可转售总量: '剩余可转售总量',
  查看账单: '查看账单',
  转售记录: '转售记录',
  授权记录: '授权记录',
  账单记录: '账单记录',
  发货记录: '发货记录',
  '通知：您有一个原购买合同解约协议待确认。': '通知：您有一个原购买合同解约协议待确认。',
  查看详情: '查看详情',
  '通知：您有一个结算单待确认。': '通知：您有一个结算单待确认。',
  '提示：除企业管理员、计费管理员可见所有订单外，其他身份用户仅可见自己下单的订单。':
    '提示：除企业管理员、计费管理员可见所有订单外，其他身份用户仅可见自己下单的订单。',
  '下单时间：': '下单时间：',
  开始日期: '开始日期',
  结束日期: '结束日期',
  '订购产品：': '订购产品：',
  '订单状态：': '订单状态：',
  '特殊订单类型：': '特殊订单类型：',
  转售订单: '转售订单',
  授权订单: '授权订单',
  后付费订单: '后付费订单',
  '支付状态：': '支付状态：',
  已失效: '已失效',
  '{slot1} 于 {slot2}授权此订单': '{slot1} 于 {slot2}授权此订单',
  被授权订单: '被授权订单',
  '订单金额：': '订单金额：',
  '合同编号：': '合同编号：',
  '单价：': '单价：',
  分开计价详单: '分开计价详单',
  '元/': '元/',
  待生效: '待生效',
  生效中: '生效中',
  交易成功: '交易成功',
  已停用: '已停用',
  配置上线时间: '配置上线时间',
  下载License: '下载License',
  下载license授权文件后请在指定的系统中导入使用: '下载license授权文件后请在指定的系统中导入使用',
  在线支付: '在线支付',
  我要开票: '我要开票',
  开通新的子服务: '开通新的子服务',
  再次购买: '再次购买',
  查看历史结算: '查看历史结算',
  授权: '授权',
  物流信息: '物流信息',
  拼命处理中: '拼命处理中',
  我已阅读并同意: '我已阅读并同意',
  不想解约: '不想解约',
  同意并下载: '同意并下载',
  '“实际消费金额”包含您已转售的量': '“实际消费金额”包含您已转售的量',
  结算周期: '结算周期',
  '消费金额(元)': '消费金额(元)',
  '已支付(元)': '已支付(元)',
  '未支付(元)': '未支付(元)',
  '注意：上线时间配置后不可更改，即订单在此时间开始进入生效期。若您购买的该产品需要技术对接，请和您的客户成功经理沟通确认后配置上线时间！':
    '注意：上线时间配置后不可更改，即订单在此时间开始进入生效期。若您购买的该产品需要技术对接，请和您的客户成功经理沟通确认后配置上线时间！',
  '指定时间：': '指定时间：',
  开始生效: '开始生效',
  原订单结束后自动延续: '原订单结束后自动延续',
  项开通: '项开通',
  上一步: '上一步',
  开通服务项: '开通服务项',
  确定开通: '确定开通',
  确定合并开票: '确定合并开票',
  合并开票: '合并开票',
  普通订单: '普通订单',
  其他订单: '其他订单',
  已终止: '已终止',
  冻结中: '冻结中',
  支付中: '支付中',
  操作成功: '操作成功',
  '您已开通新的认证服务项，即刻可以使用！': '您已开通新的认证服务项，即刻可以使用！',
  认证服务开通成功: '认证服务开通成功',
  请选择服务名称: '请选择服务名称',
  请选择订单: '请选择订单',
  发票审核中: '发票审核中',
  '开票中，请稍后': '开票中，请稍后',
  '结算单-{slot1}.pdf': '结算单-{slot1}.pdf',
  '账单修改中，不支持操作': '账单修改中，不支持操作',
  确认订单信息: '确认订单信息',
  '订单生效时间:': '订单生效时间:',
  '您可以设置订单开始生效时间，即以此时间开始方可使用相关服务': '您可以设置订单开始生效时间，即以此时间开始方可使用相关服务',
  您可以设置订单开始时间为延续当前使用订单的结束之时: '您可以设置订单开始时间为延续当前使用订单的结束之时',
  套餐名称: '套餐名称',
  '套餐附带：': '套餐附带：',
  购买个数: '购买个数',
  产品规格: '产品规格',
  '总数量：': '总数量：',
  '标准价格（元）': '标准价格（元）',
  优惠方式: '优惠方式',
  '合计价格（元）': '合计价格（元）',
  不开发票: '不开发票',
  开发票: '开发票',
  确认发票信息: '确认发票信息',
  发票抬头: '发票抬头',
  纳税人识别号: '纳税人识别号',
  发票类型: '发票类型',
  请选择发票类型: '请选择发票类型',
  发票形式: '发票形式',
  '购买方：': '购买方：',
  '商品标准价格：': '商品标准价格：',
  '已优惠金额：': '已优惠金额：',
  '发票快递费：': '发票快递费：',
  '优惠券：': '优惠券：',
  有可用优惠券: '有可用优惠券',
  已输入优惠券: '已输入优惠券',
  '总金额：': '总金额：',
  '我已阅读，同意此协议': '我已阅读，同意此协议',
  点此查看协议: '点此查看协议',
  提交订单: '提交订单',
  使用优惠券: '使用优惠券',
  优惠券编号: '优惠券编号',
  请输入优惠券编号: '请输入优惠券编号',
  再次确认后将替换之前的优惠: '再次确认后将替换之前的优惠',
  请输入数字或字母的组合: '请输入数字或字母的组合',
  '我的订单-下单': '我的订单-下单',
  '是否删除当前优惠券信息？': '是否删除当前优惠券信息？',
  无优惠: '无优惠',
  缺少参数: '缺少参数',
  '{slot1}天': '{slot1}天',
  '{slot1}年': '{slot1}年',
  '{slot1}月': '{slot1}月',
  无法使用大于等于订单金额的优惠券: '无法使用大于等于订单金额的优惠券',
  '优惠{slot1}元': '优惠{slot1}元',
  '打{slot1}折': '打{slot1}折',
  线上: '线上',
  生成订单失败: '生成订单失败',
  请选择收货地址: '请选择收货地址',
  请选择订单生效时间: '请选择订单生效时间',
  '产品价格发生变更，请点击确定，页面将自动刷新！': '产品价格发生变更，请点击确定，页面将自动刷新！',
  纳税人识别号请输入15或18位数字或字母的组合: '纳税人识别号请输入15或18位数字或字母的组合',
  '订单类型：': '订单类型：',
  所有订单: '所有订单',
  生效中订单: '生效中订单',
  待生效订单: '待生效订单',
  已失效订单: '已失效订单',
  待支付订单: '待支付订单',
  已终止订单: '已终止订单',
  历史授权: '历史授权',
  暂无记录: '暂无记录',
  '搭售-主订单号：': '搭售-主订单号：',
  '子产品价格:': '子产品价格:',
  '份/年': '份/年',
  '元/份/年': '元/份/年',
  '元/份': '元/份',
  '延时订单：': '延时订单：',
  '搭售-主商品：': '搭售-主商品：',
  订单数量: '订单数量',
  订单状态: '订单状态',
  下载请求失败: '下载请求失败',
  搭售: '搭售',
  售后赔偿: '售后赔偿',
  增加时长: '增加时长',
  试用: '试用',
  免费数量: '免费数量',
  我的余额: '我的余额',
  我的返佣: '我的返佣',
  '当前余额:': '当前余额:',
  提现: '提现',
  提现明细: '提现明细',
  资金账户: '资金账户',
  '余额（元）': '余额（元）',
  '可用余额:': '可用余额:',
  详情: '详情',
  '提现中：': '提现中：',
  '状态：': '状态：',
  全部: '全部',
  收入: '收入',
  支出: '支出',
  '时间：': '时间：',
  '1个月': '1个月',
  半年: '半年',
  '1年': '1年',
  '资金账户：': '资金账户：',
  流水号: '流水号',
  日期: '日期',
  '收入(元)': '收入(元)',
  '支出(元)': '支出(元)',
  '余额(元)': '余额(元)',
  支付方式: '支付方式',
  项目: '项目',
  购买产品: '购买产品',
  线上充值: '线上充值',
  消费结算: '消费结算',
  线下充值: '线下充值',
  提现成功: '提现成功',
  发票快递费: '发票快递费',
  代理返佣: '代理返佣',
  线下退款: '线下退款',
  渠道合作: '渠道合作',
  退款转入: '退款转入',
  ' 余额钱包': ' 余额钱包',
  ' 返佣钱包': ' 返佣钱包',
  '您还不是超级管理员，无法进行提现操作！': '您还不是超级管理员，无法进行提现操作！',
  '为保障您主体账户资金安全，当天仅能操作1次提现，今日提现次数已用完！':
    '为保障您主体账户资金安全，当天仅能操作1次提现，今日提现次数已用完！',
  '您于{slot1}发起的提现申请失败，失败原因为：{slot2}。': '您于{slot1}发起的提现申请失败，失败原因为：{slot2}。',
  份: '份',
  电子签名: '电子签名',
  SaaS签署流量包: 'SaaS签署流量包',
  '轩辕签署服务（企业版）': '轩辕签署服务（企业版）',
  企业10份: '企业10份',
  北京金格: '北京金格',
  充值: '充值',
  '充值金额:': '充值金额:',
  请输入充值金额: '请输入充值金额',
  '支付方式:': '支付方式:',
  支付宝: '支付宝',
  确认充值: '确认充值',
  请填写充值金额: '请填写充值金额',
  '请填写正确的充值金额，保留2位有效数字': '请填写正确的充值金额，保留2位有效数字',
  请选择支付方式: '请选择支付方式',
  '需支付金额:': '需支付金额:',
  '元 (快递费)': '元 (快递费)',
  查看历史结算详单: '查看历史结算详单',
  使用余额支付: '使用余额支付',
  '我的账户余额:': '我的账户余额:',
  请输入签署密码进行支付: '请输入签署密码进行支付',
  '还没有签署密码?': '还没有签署密码?',
  去设置签署密码: '去设置签署密码',
  使用第三方支付: '使用第三方支付',
  微信: '微信',
  对公支付: '对公支付',
  银行转账: '银行转账',
  确认支付: '确认支付',
  恭喜你下单支付成功: '恭喜你下单支付成功',
  '请立即添加官方企微，协助您上线生效套餐。': '请立即添加官方企微，协助您上线生效套餐。',
  '首次添加另可以赠送证据报告一份，用于向对方说明电子合同有效性。': '首次添加另可以赠送证据报告一份，用于向对方说明电子合同有效性。',
  历史结算清单: '历史结算清单',
  支付记录号: '支付记录号',
  费用: '费用',
  支付状态: '支付状态',
  专属汇款账号: '专属汇款账号',
  '证明文件正在生成中，请勿关闭当前页面': '证明文件正在生成中，请勿关闭当前页面',
  '平台收到银行汇款后十分钟内将自动匹配到您的订单，并为您完成支付。注：专属汇款账号是在平台发票信息显示账号下设立的子账号，二者为同一账号。':
    '平台收到银行汇款后十分钟内将自动匹配到您的订单，并为您完成支付。注：专属汇款账号是在平台发票信息显示账号下设立的子账号，二者为同一账号。',
  '您选择对公支付，请使用企业账户汇款，如使用个人账户可能有失败风险！':
    '您选择对公支付，请使用企业账户汇款，如使用个人账户可能有失败风险！',
  '开户名称：': '开户名称：',
  '开户银行：': '开户银行：',
  '专属汇款账号：': '专属汇款账号：',
  '付款金额：': '付款金额：',
  一键复制账户信息: '一键复制账户信息',
  下载专属帐号电子证明: '下载专属帐号电子证明',
  '您选择对公支付，需要在72小时内完成汇款到账，超过时订单将会关闭，请勿多汇款或少汇款！':
    '您选择对公支付，需要在72小时内完成汇款到账，超过时订单将会关闭，请勿多汇款或少汇款！',
  '微信支付(请用微信扫描二维码)': '微信支付(请用微信扫描二维码)',
  支付成功: '支付成功',
  '账户信息已经复制成功，您可以发送给打款人进行汇款！': '账户信息已经复制成功，您可以发送给打款人进行汇款！',
  证明文件生成完成: '证明文件生成完成',
  '证明文件生成超时，请重试': '证明文件生成超时，请重试',
  '支付宝支付(请用支付宝扫描二维码)': '支付宝支付(请用支付宝扫描二维码)',
  转售开始时间: '转售开始时间',
  授权开始时间: '授权开始时间',
  转售结束时间: '转售结束时间',
  授权结束时间: '授权结束时间',
  授权状态: '授权状态',
  授权方式: '授权方式',
  授权方: '授权方',
  被转售方名称: '被转售方名称',
  被授权方名称: '被授权方名称',
  转售时间: '转售时间',
  授权时间: '授权时间',
  授权量: '授权量',
  状态: '状态',
  授权中: '授权中',
  开通: '开通',
  查看: '查看',
  备注: '备注',
  查看物流: '查看物流',
  设置备注: '设置备注',
  请输入备注内容: '请输入备注内容',
  已成功开通子服务项: '已成功开通子服务项',
  最大输入40个字符: '最大输入40个字符',
  '请确认是否取消“{slot1}”订单的授权，取消后，收回当前授权量的管理,可能会影响“{slot2}”使用。':
    '请确认是否取消“{slot1}”订单的授权，取消后，收回当前授权量的管理,可能会影响“{slot2}”使用。',
  取消授权: '取消授权',
  订单: '订单',
  转售: '转售',
  确认: '确认',
  订单转售: '订单转售',
  转售确认: '转售确认',
  授权确认: '授权确认',
  确认转售: '确认转售',
  确认授权: '确认授权',
  '可使用方：': '可使用方：',
  '本次新增的被转售方信息如下：': '本次新增的被转售方信息如下：',
  被转售方: '被转售方',
  被授权方: '被授权方',
  '授权订单总量/最大可用量': '授权订单总量/最大可用量',
  '授权须知：': '授权须知：',
  '在操作本转赠功能之前，请您仔细阅读本提醒内容，您实际使用了本功能即视为您已经阅读并认可本提醒内容；若您不接受本提醒内容，请您不要进行下一步操作。':
    '在操作本转赠功能之前，请您仔细阅读本提醒内容，您实际使用了本功能即视为您已经阅读并认可本提醒内容；若您不接受本提醒内容，请您不要进行下一步操作。',
  '1、本授权指：我司可将我司购买的e签宝服务中的全部或部分授权给我司提供的名单中的关联公司或合作伙伴。我司与授权使用方之间的法律关系由我司与授权使用方自行确认。':
    '1、本授权指：我司可将我司购买的e签宝服务中的全部或部分授权给我司提供的名单中的关联公司或合作伙伴。我司与授权使用方之间的法律关系由我司与授权使用方自行确认。',
  '2、授权使用方使用e签宝服务的内容在e签宝提供的产品范围内，由我司确认。我司无条件接受e签宝调整可授权的产品范围，其影响由我司自行承担。':
    '2、授权使用方使用e签宝服务的内容在e签宝提供的产品范围内，由我司确认。我司无条件接受e签宝调整可授权的产品范围，其影响由我司自行承担。',
  '3、开通订单授权功能及进行授权，不改变我司与e签宝签署的《软件技术服务协议》等合同的权利义务关系，另有约定的除外。':
    '3、开通订单授权功能及进行授权，不改变我司与e签宝签署的《软件技术服务协议》等合同的权利义务关系，另有约定的除外。',
  '4、我司确保授权使用方完成实名认证，并按照电子签名法的要求合法合规使用电子签名服务。':
    '4、我司确保授权使用方完成实名认证，并按照电子签名法的要求合法合规使用电子签名服务。',
  '5、我司知悉e签宝非标类产品需要增购e签宝提供的《电子证据法律咨询服务》或《互联网业务流程公证服务》，我司确保可授权用户已经增购相应产品，否则贵司有权立刻关闭授权功能。':
    '5、我司知悉e签宝非标类产品需要增购e签宝提供的《电子证据法律咨询服务》或《互联网业务流程公证服务》，我司确保可授权用户已经增购相应产品，否则贵司有权立刻关闭授权功能。',
  '转售须知：': '转售须知：',
  '在操作本转售功能之前，请您仔细阅读本提醒内容，您实际使用了本功能即视为您已经阅读并认可本提醒内容；若您不接受本提醒内容，请您不要进行下一步操作。':
    '在操作本转售功能之前，请您仔细阅读本提醒内容，您实际使用了本功能即视为您已经阅读并认可本提醒内容；若您不接受本提醒内容，请您不要进行下一步操作。',
  '1、使用本功能，您可以将您所购买的e签宝服务中的全部或部分转售给您的关联公司、合作伙伴或者客户使用。':
    '1、使用本功能，您可以将您所购买的e签宝服务中的全部或部分转售给您的关联公司、合作伙伴或者客户使用。',
  '2、使用本功能，不会改变您和e签宝所签署软件产品相关服务合同之权利义务关系，您需合法的使用该转售功能并自行对您的行为负责。':
    '2、使用本功能，不会改变您和e签宝所签署软件产品相关服务合同之权利义务关系，您需合法的使用该转售功能并自行对您的行为负责。',
  '3、您应确保您的转售使用方完成实名认证并按照电子签名法的要求合法合规的使用电子签名服务，e签宝不对您的转售使用方未按照法律规定使用电子签名的行为负责。':
    '3、您应确保您的转售使用方完成实名认证并按照电子签名法的要求合法合规的使用电子签名服务，e签宝不对您的转售使用方未按照法律规定使用电子签名的行为负责。',
  '4、使用本功能，您应确保您已获得转售使用方给予您查看其使用电子签名签署记录的相关授权，并由您自行维护您与转售使用方间包括但不限于订单余额提醒、续充维护、隐私保护、费用结算、开票及其他相关服务，由此引发的争议由您自行处理，e签宝不承担任何责任。':
    '4、使用本功能，您应确保您已获得转售使用方给予您查看其使用电子签名签署记录的相关授权，并由您自行维护您与转售使用方间包括但不限于订单余额提醒、续充维护、隐私保护、费用结算、开票及其他相关服务，由此引发的争议由您自行处理，e签宝不承担任何责任。',
  '5、因您的转售使用方与e签宝不存在合同关系，故您与您的转售使用方之间的法律关系由您自行负责，e签宝不向您的转售使用方提供出证等法律服务，您因确保您的转售使用方知晓并同意。':
    '5、因您的转售使用方与e签宝不存在合同关系，故您与您的转售使用方之间的法律关系由您自行负责，e签宝不向您的转售使用方提供出证等法律服务，您因确保您的转售使用方知晓并同意。',
  '6、您因转售行为导致您的转售使用方不能正常使用电子签名服务或因使用服务引发纠纷的，您应自行处理，若因此给e签宝造成损失的，e签宝有权向您进行追偿。':
    '6、您因转售行为导致您的转售使用方不能正常使用电子签名服务或因使用服务引发纠纷的，您应自行处理，若因此给e签宝造成损失的，e签宝有权向您进行追偿。',
  '7、e签宝保留随时关闭该功能的权利。': '7、e签宝保留随时关闭该功能的权利。',
  请输入签署密码进行: '请输入签署密码进行',
  请输入签署密码进行授权: '请输入签署密码进行授权',
  确认授权成功: '确认授权成功',
  确认转售成功: '确认转售成功',
  提交: '提交',
  重置: '重置',
  '有效期{year}年': '有效期{year}年',
  有效期无限: '有效期无限',
  购买份数: '购买份数',
  商品标准价格: '商品标准价格',
  优惠券: '优惠券',
  已优惠: '已优惠',
  实际支付金额: '实际支付金额',
  订单生效时间: '订单生效时间',
  '您可以设置订单开始生效时间，即以此时间开始方可使用相关服务。': '您可以设置订单开始生效时间，即以此时间开始方可使用相关服务。',
  '{value} 年': '{value} 年',
  '{value} 月': '{value} 月',
  '{value} 日': '{value} 日',
  优惠码: '优惠码',
  余额支付: '余额支付',
  '对不起！您的账户余额不足。': '对不起！您的账户余额不足。',
  '折扣{slot1}%': '折扣{slot1}%',
  '产品价格发生变更，请点击确定，页面将自动刷新': '产品价格发生变更，请点击确定，页面将自动刷新',
  支付宝支付: '支付宝支付',
  微信支付: '微信支付',
  请确认支付是否完成: '请确认支付是否完成',
  已完成支付: '已完成支付',
  遇到问题重新支付: '遇到问题重新支付',
  购买成功: '购买成功',
  '正在获取支付结果，请稍后': '正在获取支付结果，请稍后',
  '支付失败，请重新尝试支付': '支付失败，请重新尝试支付',
  用户取消: '用户取消',
  超时取消: '超时取消',
  异常终止: '异常终止',
  '总金额:': '总金额:',
  主体: '主体',
  产品购买合同: '产品购买合同',
  商务代表: '商务代表',
  联系电话: '联系电话',
  订单ID: '订单ID',
  商品名称: '商品名称',
  '订单规格（份）': '订单规格（份）',
  '（按量后付）': '（按量后付）',
  '订单成交总金额（元）': '订单成交总金额（元）',
  '（已出账）': '（已出账）',
  '已付款金额（元）': '已付款金额（元）',
  '本次应支付金额（元）': '本次应支付金额（元）',
  '《e签宝产品购买协议》': '《e签宝产品购买协议》',
  确认购买信息: '确认购买信息',
  线下转账: '线下转账',
  公司名称: '公司名称',
  杭州天谷信息科技有限公司: '杭州天谷信息科技有限公司',
  税号: '税号',
  '浙江省杭州市西湖区西斗门路3号 天堂软件园D幢19层': '浙江省杭州市西湖区西斗门路3号 天堂软件园D幢19层',
  平安银行杭州高新支行: '平安银行杭州高新支行',
  您可以通过网银或柜台直接将相应金额转账至e签宝银行账户: '您可以通过网银或柜台直接将相应金额转账至e签宝银行账户',
  请用浏览器打开: '请用浏览器打开',
  '请确认是否选择下线转账，确认后将不能线上支付，同时，也会完成邀请支付':
    '请确认是否选择下线转账，确认后将不能线上支付，同时，也会完成邀请支付',
  '您已选择线下支付，': '您已选择线下支付，',
  支付成功后订单状态将会更新: '支付成功后订单状态将会更新',
  线下转账信息: '线下转账信息',
  复制: '复制',
  订单规格: '订单规格',
  复制成功: '复制成功',
  '本次总需支付金额：': '本次总需支付金额：',
  '商务代表：': '商务代表：',
  '我已阅读，同意此': '我已阅读，同意此',
  '(您可以通过网银或柜台直接将相应金额转账至e签宝银行账户)': '(您可以通过网银或柜台直接将相应金额转账至e签宝银行账户)',
  '公司名称：': '公司名称：',
  '税号：': '税号：',
  '地址：': '地址：',
  浙江省杭州市西湖区西斗门路3号天堂软件园D幢19层: '浙江省杭州市西湖区西斗门路3号天堂软件园D幢19层',
  '电话：': '电话：',
  '银行账号：': '银行账号：',
  确认支付方式: '确认支付方式',
  文件: '文件',
  '（{slot1}份）': '（{slot1}份）',
  '您已选择线下支付，支付成功后订单状态将及时更新': '您已选择线下支付，支付成功后订单状态将及时更新',
  '恭喜！您已支付成功！': '恭喜！您已支付成功！',
  '提示：您可以通过e签宝官网在': '提示：您可以通过e签宝官网在',
  '中查看相关订单及使用情况。': '中查看相关订单及使用情况。',
  '抱歉，支付失败！': '抱歉，支付失败！',
  '失败原因：': '失败原因：',
  '请稍等，支付确认中…': '请稍等，支付确认中…',
  '线下转账支付信息：': '线下转账支付信息：',
  '支付信息已复制成功，直接操作粘贴即可。': '支付信息已复制成功，直接操作粘贴即可。',
  '恭喜，您的开票申请已提交成功！': '恭喜，您的开票申请已提交成功！',
  查看全部订单: '查看全部订单',
  '合并开票订单：': '合并开票订单：',
  '{slot1}，按归属公司分别合并开票': '{slot1}，按归属公司分别合并开票',
  归属公司: '归属公司',
  '订单金额(元)': '订单金额(元)',
  电子发票已开: '电子发票已开',
  开票失败: '开票失败',
  获取发票: '获取发票',
  '由于您的开票申请涉及未全额付款订单，因此需要2个工作日的审批后开具！':
    '由于您的开票申请涉及未全额付款订单，因此需要2个工作日的审批后开具！',
  '（请在订单管理中及时获取开具的电子发票）': '（请在订单管理中及时获取开具的电子发票）',
  '提示：您申请开具的发票将在7个工作日内寄出，请注意查收！': '提示：您申请开具的发票将在7个工作日内寄出，请注意查收！',
  支付结果: '支付结果',
  '若您尚未完成企业实名认证，该产品将无法正常启用': '若您尚未完成企业实名认证，该产品将无法正常启用',
  '商品正在加紧备货，预计1-2周发出': '商品正在加紧备货，预计1-2周发出',
  查看余额: '查看余额',
  重新支付: '重新支付',
  支付遇到问题: '支付遇到问题',
  '发票抬头：': '发票抬头：',
  订单金额: '订单金额',
  警告: '警告',
  '若您尚未完成企业实名认证，该产品将无法正常启用！': '若您尚未完成企业实名认证，该产品将无法正常启用！',
  支付失败: '支付失败',
  '暂不支持这个method：{slot1}': '暂不支持这个method：{slot1}',
  天: '天',
  '微应用 demo': '微应用 demo',
  文件hash: '文件hash',
  '导出结果中暂不包含当日耗用数据，敬请谅解': '导出结果中暂不包含当日耗用数据，敬请谅解',
  提交成功: '提交成功',
  '系统将在2个工作日内将对应消费记录发送到对应邮箱，或可查询已导出记录进行自助下载':
    '系统将在2个工作日内将对应消费记录发送到对应邮箱，或可查询已导出记录进行自助下载',
  '解压密码为：': '解压密码为：',
  文件名: '文件名',
  导出时间: '导出时间',
  导出结果: '导出结果',
  解压密码: '解压密码',
  未加密: '未加密',
  导出中: '导出中',
  请输入正确的邮箱地址: '请输入正确的邮箱地址',
  已授权: '已授权',
  未授权: '未授权',
  系统异常: '系统异常',
  '订单上线提醒：': '订单上线提醒：',
  '1、订单上线后，所购商品套餐有效期不可更改与延期。': '1、订单上线后，所购商品套餐有效期不可更改与延期。',
  '2、如有接口对接，建议在系统完整对接完，再进行订单上线。': '2、如有接口对接，建议在系统完整对接完，再进行订单上线。',
  汇款账户信息: '汇款账户信息',
  请先阅读并同意协议: '请先阅读并同意协议',
  收款户名: '收款户名',
  收款银行: '收款银行',
  汇款账号: '汇款账号',
  复制账户信息: '复制账户信息',
  '收款户名：': '收款户名：',
  '收款银行：': '收款银行：',
  '汇款账号：': '汇款账号：',
  兑换优惠券: '兑换优惠券',
  请输入优惠券码: '请输入优惠券码',
  确认兑换: '确认兑换',
  发票信息: '发票信息',
  开票银行: '开票银行',
  请选择开票银行: '请选择开票银行',
  '邮箱地址：': '邮箱地址：',
  请输入正确的银行账号: '请输入正确的银行账号',
  请输入正确的手机号码: '请输入正确的手机号码',
  '纳税人识别号：': '纳税人识别号：',
  '开户行：': '开户行：',
  '开票电话：': '开票电话：',
  '发票类型：': '发票类型：',
  '发票形式：': '发票形式：',
  '开票地址：': '开票地址：',
  修改开票信息: '修改开票信息',
  收货地址: '收货地址',
  '地址信息：': '地址信息：',
  '详细信息：': '详细信息：',
  '收货人：': '收货人：',
  选择收货地址: '选择收货地址',
  新建地址: '新建地址',
  选择其他地址: '选择其他地址',
  使用新地址: '使用新地址',
  企业账户: '企业账户',
  确认订单: '确认订单',
  支付: '支付',
  '抱歉，单次发票可开具金额为1999999.99，请联系客服获取发票。': '抱歉，单次发票可开具金额为1999999.99，请联系客服获取发票。',
  倒计时: '倒计时',
  '支付超时已关闭，你可重新下单': '支付超时已关闭，你可重新下单',
  '{time}后支付关闭': '<span class="countdown-time">{time}</span>后支付关闭',
  '支付遇到问题？': '支付遇到问题？',
  点击获取客服支持: '点击获取客服支持',
  永久有效: '永久有效',
  '已为该订单生成专属汇款账号，是平台收款账号下设的专属子账号。': '已为该订单生成专属汇款账号，是平台收款账号下设的专属子账号。',
  下载证明: '下载证明',
  '请准确按照订单金额对公汇款；': '请准确按照订单金额对公汇款；',
  '72小时内未转账成功订单会超时关闭。': '72小时内未转账成功订单会超时关闭。',
  '汇款成功后，订单将在10分钟内生效': '汇款成功后，订单将在10分钟内生效',
  '去转账，等待支付结果': '去转账，等待支付结果',
  修改签署密码: '修改签署密码',
  '银行转账（对公支付）': '银行转账（对公支付）',
  账户余额支付: '账户余额支付',
  使用支付宝扫码支付: '使用支付宝扫码支付',
  使用微信扫码支付: '使用微信扫码支付',
  商品总价: '商品总价',
  优惠: '优惠',
  输入优惠券码: '输入优惠券码',
  暂无优惠: '暂无优惠',
  不使用优惠: '不使用优惠',
  '实付款：': '实付款：',
  服务协议: '服务协议',
  立即支付: '立即支付',
  余额: '余额',
  优惠券已存在: '优惠券已存在',
  产品信息: '产品信息',
  '订阅内容：': '订阅内容：',
  '有效期：': '有效期：',
  '产品规格：': '产品规格：',
  购买主体: '购买主体',
  生效时间: '生效时间',
  '当前有生效中的订单，{data}到期': '当前有生效中的订单，{data}到期',
  '续延订单在原订单结束后生效，或原订单提前消耗完续延订单自动生效。': '续延订单在原订单结束后生效，或原订单提前消耗完续延订单自动生效。',
  购买数量: '购买数量',
  指定时间生效: '指定时间生效',
  订单续延生效: '订单续延生效',
  订单完成后开发票: '订单完成后开发票',
  填写发票信息: '填写发票信息',
  订单列表: '订单列表',
  微信扫码添加官方客服微信: '微信扫码添加官方客服微信',
  首次添加可赠送证据报告一份: '首次添加可赠送证据报告一份',
  企业微信: '企业微信',
  转账结果确认中: '转账结果确认中',
  '汇款成功后，订单将在10分钟内生效，请耐心等待': '汇款成功后，订单将在10分钟内生效，请耐心等待',
  '开票银行：': '开票银行：',
  '预计1-2周发出': '预计1-2周发出',
  账户信息复制成功: '账户信息复制成功',
  实际使用方: '实际使用方',
  剩余量: '剩余量',
  '当前登录的企业和购买链接所属的企业（{epBindOrgName}）不一致，请选择正确企业空间或者重新登录':
    '当前登录的企业和购买链接所属的企业（{epBindOrgName}）不一致，请选择正确企业空间或者重新登录',
  专属特惠: '专属特惠',
  原价: '原价',
  '顺手购活动暂不支持对公转账，请选择其他方式支付': '顺手购活动暂不支持对公转账，请选择其他方式支付',
  配置生效时间: '配置生效时间',
  '配置生效时间后，商品套餐有效期不可更改或延期！若涉及接口对接等前置流程，建议系统对接完成后再配置生效': '配置生效时间后，商品套餐有效期不可更改或延期！若涉及接口对接等前置流程，建议系统对接完成后再配置生效',
  '订单生效时间配置后不可更改或延期，确认配置？': '订单生效时间配置后不可更改或延期，确认配置？',
  '暂不配置': '暂不配置',
  
  '根据税务局相关规定，软件类产品需单独开具发票，因此您可能会收到同一服务主体出具的多张发票，所有发票均真实有效，可正常使用。': '根据税务局相关规定，软件类产品需单独开具发票，因此您可能会收到同一服务主体出具的多张发票，所有发票均真实有效，可正常使用。',
}
